export const isSupportedBrowser = () => {
  return (
    window.navigator.userAgent.indexOf("Chrome") !== -1 ||
    window.navigator.userAgent.indexOf("Safari") !== -1
  );
};
